import React from 'react';

/** Warning about PAGINATION_INTERNAL_PAGES_LIMIT */
export default function PaginationNoContentOverWarning() {
  return (
    <h2 style={{ padding: '100px 0', textAlign: 'center' }}>
      We are not able to show more data here.
      <br />
      You can Download CSV to see full history.
    </h2>
  );
}
